<!--==================================
=            LISTMESSAGES            =
===================================-->
<template>
  <v-card class="pa-3 ma-2 elevation-0">
    <v-list two-line>
      <template v-for="(item, index) in items">
        <v-subheader v-if="item.header" :key="item.header" inset>
          {{ item.header }}
        </v-subheader>

        <v-divider v-else-if="item.divider" :key="index" inset></v-divider>

        <v-list-item v-else :key="item.title" ripple>
          <v-list-item-avatar>
            <img :src="item.avatar" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title v-html="item.title"></v-list-item-title>
            <v-list-item-subtitle v-html="item.subtitle"></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list>
  </v-card>
</template>
<script>
export default {
  data() {
    return {
      items: [
        {
          header: "Today"
        },
        { divider: true },
        {
          avatar: "https://picsum.photos/250/300?image=660",
          title: "Meeting @ Noon",
          subtitle:
            "<span class='text--primary'>Spike Lee</span> &mdash; I'll be in your neighborhood"
        },
        {
          avatar: "https://picsum.photos/250/300?image=821",
          title: 'Summer BBQ <span class="grey--text text--lighten-1"></span>',
          subtitle:
            "<span class='text--primary'>to Operations support</span> &mdash; Wish I could come."
        },
        {
          avatar: "https://picsum.photos/250/300?image=783",
          title: "Yes yes",
          subtitle:
            "<span class='text--primary'>Bella</span> &mdash; Do you have Paris recommendations"
        },
        {
          header: "Yesterday"
        },
        { divider: true },
        {
          avatar: "https://picsum.photos/250/300?image=1006",
          title: "Dinner tonight?",
          subtitle:
            "<span class='text--primary'>LaToya</span> &mdash; Do you want to hang out?"
        },
        {
          avatar: "https://picsum.photos/250/300?image=146",
          title: "So long",
          subtitle:
            "<span class='text--primary'>Nancy</span> &mdash; Do you see what time it is?"
        }
      ]
    };
  }
};
</script>

<!--====  End of LISTMESSAGES  ====-->
